import { render } from "./add-group-modal.vue?vue&type=template&id=76451dcb"
import script from "./add-group-modal.vue?vue&type=script&lang=js"
export * from "./add-group-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__